<mat-slide-toggle
    #element
    [color]="color"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onSlideToggleChange($event)"
    disableRipple
>
    {{ !element.checked ? texts[1] : texts[0] }}
</mat-slide-toggle>
